<script setup lang="ts">
import { onMounted, toRefs } from 'vue';
import { useCalendarStore } from '@/store';
import { PastDocumentationGoal } from './index';
import { PastResultInterface } from '@/types';
import { useDateTime } from '@/composables';

const calendarStore = useCalendarStore();

interface Props {
  data: PastResultInterface;
}
const props = defineProps<Props>();

const { data } = toRefs(props);

onMounted(() => init());

const formatTimes = (dates: PastResultInterface['event']['time']) => {
  const startTime = new Intl.DateTimeFormat('default', {
    hour: 'numeric',
    minute: 'numeric',
  }).format(useDateTime().fromUTCStringToLocalDate(dates[0]));

  const endTime = new Intl.DateTimeFormat('default', {
    hour: 'numeric',
    minute: 'numeric',
  }).format(useDateTime().fromUTCStringToLocalDate(dates[1]));
  return `${startTime.toLowerCase().replace(' ', '')} - ${endTime.toLowerCase().replace(' ', '')}`;
};

const init = () => {
  calendarStore.selectedEvent.event_process_type = 'this';
};
</script>

<template>
  <div class="documentation-content p-3 my-3 border-rounded">
    <div class="flex my-1 text-sm">
      <b class="mr-1">{{ data.event.date }}</b>
      -
      <div class="dark-medium ml-1">{{ formatTimes(data.event.time) }}</div>
    </div>

    <!-- eslint-disable vue/no-v-html -->
    <p class="my-2 text-justify" v-html="data.result.notes"></p>
    <!--eslint-enable-->

    <PastDocumentationGoal v-for="goal in data.result.treatment_goal_measurements" :key="goal.id" :data="goal" />
  </div>
</template>

<style scoped lang="scss">
.documentation-content {
  background: #fff;
  color: $grayDark;
}
.border-rounded {
  border-radius: 8px;
}
.dark-medium {
  color: $grayDark;
}
</style>
